export const unsignedOverwriteFileName = (
  formCompletionId: string,
  s3Key?: string | null,
): string | undefined => {
  const basename = s3Key?.split('/').pop();
  if (!basename) return undefined;
  const prefix = `${formCompletionId}_`;
  return basename.startsWith(prefix) ? basename.slice(prefix.length) : basename;
};
